import React, { FC, useEffect, useState } from "react";
import queryString from "query-string";
import Header from "../../sections/Header";
import Company from "../admin/CompanyInformation";
import { IMainForm } from "./Create";
import { service as axiosService } from "../../../tools/service";
import { company } from "./Index";
import Theme from "../admin/Theme";
import Service, { service, SlotType } from "../admin/Service";

import { uniqueId } from "lodash";
import {
  editCompany,
  editService,
  editSlotType
} from "../../../entities/EditCompany";

import { Link, useHistory } from "react-router-dom";
import UploadImage from "../../../assets/images/upload/upload img.png";

import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { store } from "react-notifications-component";

import GoogleAnalyticsConfiguration from "../../../googleAnalytics/googleAnalyticsConfiguration";

export const clean = () => {
  localStorage.removeItem("service");
  localStorage.removeItem("multi-service");
  localStorage.removeItem("multi-service-backup");
  localStorage.removeItem("openService");
};

const EditWidget: FC = () => {
  const [values, setValues] = useState<string[]>([]);
  //change when s3 bucket is running
  const [file, setFile] = useState<string>();
  const [base64, setBase64] = useState<any>();
  //end change when s3 bucket is running
  const [errors, setErrors] = useState({});
  let errorService = "";

  const [form, setForm] = useState<IMainForm>({
    company: {
      name: "",
      streetAddress: "",
      place: "",
      city: "",
      state: "",
      zipCode: "",
      img: "",
      successwareCompanyId: "",
    },
    themes: {
      primaryColor: "",
      secondaryColor: "",
      iconColor: "",
      primaryFont: "",
      primaryFontColor: "",
      secondaryFontColor: "",
    },
  });
  const [editCompany, setEditCompany] = useState<company>();
  const [multiService, setMultiService] = useState<service[]>([]);
  const [serviceConfig, setServiceConfig] = useState<service[]>([]);
  const [updateCompanyInfo, setUpdateCompanyInfo] = useState<editCompany>();
  const [idTheme, setIdTheme] = useState("");
  const [editServiceCurrent, setEditServiceCurrent] = useState<service[]>([]);
  const [imgUploaded, setImagUpload] = useState(UploadImage ?? "");
  const [serverDataReady, setServerDataReady] = useState(false);

  let history = useHistory();

  const getBase64 = (file: any) => {
    return new Promise((resolve) => {
      let fileInfo;
      // Make new FileReader
      let reader = new FileReader();
      // Convert the file to base64 text
      reader.readAsDataURL(file);
      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        let baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };
  const handleOnChange = React.useCallback(
    (formToEdit: keyof IMainForm, prop: string, value: any) => {
      const handleError = { ...errors } as { [key: string]: any };
      const newFormToEdit = { ...form[formToEdit] } as { [key: string]: any };
      //change when s3 bucket works
      if (prop === "img") {
        let file = value[0];
        getBase64(file)
          .then((result) => {
            file["base64"] = result;
            setBase64(result);
            setFile(file);
            newFormToEdit[prop] = result;
            setImagUpload(result as any);
            showNotification("Image", "Image uploaded successfully", "success");
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (prop === "state") {
        newFormToEdit[prop] = value.toUpperCase().replace(/[^A-Za-z]/gi, "");
      } else newFormToEdit[prop] = value;
      handleError[prop] = 0;
      setErrors(handleError);
      //end change when s3 bucket works
      setForm({
        ...form,
        [formToEdit]: newFormToEdit,
      });
    },
    [form]
  );
  const showNotification = (title: string, message: string, type: any) => {
    store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
  };


  /**
   *  This method will validate the form data
   * @param countForm  
   * @param services 
   * @returns 
   */
  function formDataValidation(countForm: IMainForm, services: any): boolean {
    let validData = true;

    //check form data. It did not check the service dro down in middle
    if (
      countForm.company.city.length === 0 ||
      countForm.company.name.length === 0 ||
      countForm.company.state.length === 0 ||
      countForm.company.zipCode.length === 0 ||
      (countForm.company.img.length === 0 && imgUploaded.length === 0) ||
      countForm.company.streetAddress.length === 0 ||
      services.length === 0 ||
      countForm.themes.iconColor.length === 0 ||
      countForm.themes.primaryColor.length === 0 ||
      countForm.themes.primaryFont.length === 0 ||
      countForm.themes.secondaryColor.length === 0 ||
      countForm.themes.primaryFontColor.length === 0 ||
      countForm.themes.secondaryFontColor.length === 0
    )
      validData = false;
    return validData;
  }


  /**
   *  This service will return the a widget from backend.
   *  This method get call during the initialization of edit page
   *  if success it will return 
   *   com.successware.customerlinkportal.db.model.Company 
   * @param widgetId 
   * @param companyId 
   */
  const reteriveCompayFromServer = (widgetId: string, companyId: string) => {
    axiosService
      .get(`api/widgets/${widgetId}/company/${companyId}/logo`)
      .then((response) => {
        if (response.data && response.data.length) setImagUpload(response.data);
        else setImagUpload(UploadImage);
      });
    axiosService
      .get(`api/widgets/${widgetId}/company/${companyId}`)
      .then((response) => {

        const tempForm = { ...form };
        let tempService = { ...multiService };
        tempForm.company.successwareCompanyId =
          response.data["successwareCompanyId"];
        tempForm.company.city = response.data["city"];
        tempForm.company.img = "";
        tempForm.company.name = response.data["name"];
        tempForm.company.place = response.data["place"];
        tempForm.company.state = response.data["state"];
        tempForm.company.streetAddress = response.data["streetAddress"];
        tempForm.company.zipCode = response.data["zipCode"];
        localStorage.setItem(
          "currentCompanySelected",
          response.data["successwareCompanyId"]
        );

        // populate com.successware.customerlinkportal.db.model.service 
        tempService = response.data["services"];

        // it will append prefix service- slot- jobt- to db service id, slot id and job id 
        const avaliableServices: service[] = tempService.reduce((items, it) => {
          const slotTypes: SlotType[] = it.slotTypes.reduce((stypes: { id: any; slotType: any; slotFriendlyName: { id: string; value: any; }; jobTypes: any; }[], st: { id: any; slotType: any; slotFriendlyName: { toString: () => any; }; jobTypes: any[]; }) => {
            stypes.push({
              id: st.id,
              slotType: st.slotType,
              slotFriendlyName: {
                id: uniqueId("slot-"),
                value: st.slotFriendlyName.toString(),
              },
              jobTypes: st.jobTypes.map((val: { id: any; groupName: any; jobClass: any; jobType: any; jobTypeDesc: any; jobFriendlyName: { toString: () => any; }; }) => ({
                id: val.id,
                groupName: val.groupName,
                jobClass: val.jobClass,
                jobType: val.jobType,
                jobTypeDesc: val.jobTypeDesc,
                jobFriendlyName: {
                  id: uniqueId("jobt-"),
                  value: val.jobFriendlyName.toString(),
                },
              })),
            });
            return stypes;
          }, [] as SlotType[]);
          items.push({
            active: true,
            id: `service-${it.serviceType}`,
            serviceType: it.serviceType,
            serviceFriendlyName: {
              id: uniqueId("service-"),
              value: it.serviceFriendlyName?.toString()
            },
            slotTypes,
          });
          return items;
        }, [] as service[]);

        console.log("reteriveCompayFromServer: " + avaliableServices);

        setEditServiceCurrent(avaliableServices);

        // save service to localStorage
        localStorage.setItem("service", JSON.stringify(avaliableServices));
        localStorage.removeItem("openService");

        //populate theme
        setIdTheme(response.data.themes[0].id);
        tempForm.themes.iconColor = response.data.themes[0]["iconColor"] ?? "";
        tempForm.themes.primaryColor =
          response.data.themes[0]["primaryColor"] ?? "";
        tempForm.themes.primaryFont =
          response.data.themes[0]["primaryFont"] ?? "";
        tempForm.themes.secondaryColor =
          response.data.themes[0]["secondaryColor"] ?? "";
        tempForm.themes.primaryFontColor =
          response.data.themes[0]["primaryFontColor"] ?? "";
        tempForm.themes.secondaryFontColor =
          response.data.themes[0]["secondaryFontColor"] ?? "";
        setForm(tempForm);
        setServerDataReady(true)
      });
  };

  const updateCompany = () => {
    const services = JSON.parse(
      localStorage.getItem("service") || "[]"
    ) as service[];
    const sendInfoCompanyToUpdate = { ...updateCompanyInfo };
    const currentForm = { ...form };
    const searchUrl = queryString.parse(window.location.search);

    const openService = JSON.parse(localStorage.getItem("openService") || "0");
    if (services.length > 0) {
      const handleError = { ...errors } as { [key: string]: any };
      handleError["slotTypes"] = 0;
      setErrors(handleError);
    }

    // validation
    if (formDataValidation(currentForm, services) && openService === 0) {
      sendInfoCompanyToUpdate.successwareCompanyId = JSON.parse(
        localStorage.getItem("currentCompanySelected") || ""
      );
      sendInfoCompanyToUpdate.id = searchUrl.companyId as string;
      sendInfoCompanyToUpdate.name = currentForm.company.name;
      sendInfoCompanyToUpdate.streetAddress = currentForm.company.streetAddress;
      sendInfoCompanyToUpdate.place = currentForm.company.place;
      sendInfoCompanyToUpdate.city = currentForm.company.city;
      sendInfoCompanyToUpdate.state = currentForm.company.state;
      sendInfoCompanyToUpdate.zipCode = currentForm.company.zipCode;
      sendInfoCompanyToUpdate.img = currentForm.company.img;

      const serviceFromLocalStorage = JSON.parse(
        localStorage.getItem("service") || "[]"
      ) as any[];


      // Only interested in active service
      const serviceConfigReady = serviceFromLocalStorage.filter(s => { return (s.active) });

      // logice to populate serivces drop down structire
      const newService: editService[] = serviceConfigReady?.reduce(
        (items, it) => {
          const slotTypes: editSlotType[] = it.slotTypes?.reduce(
            (stypes: any, st: any) => {
              stypes.push({
                id: "",
                slotType: st.slotType,
                slotFriendlyName:
                  (st.slotFriendlyName.value &&
                    st.slotFriendlyName.value.length > 0
                    ? st.slotFriendlyName.value
                    : st.slotType) ?? "",
                jobTypes: st.jobTypes.map((val: any) => ({
                  id: "",
                  groupName: val.groupName,
                  jobClass: val.jobClass,
                  jobType: val.jobType,
                  jobTypeDesc: val.jobTypeDesc,
                  jobFriendlyName:
                    (val.jobFriendlyName.value &&
                      val.jobFriendlyName.value.length > 0
                      ? val.jobFriendlyName.value
                      : val.jobTypeDesc) ?? "",
                })),
              });
              return stypes;
            },
            [] as editSlotType[]
          );
          items.push({
            id: "",
            serviceType: it.serviceType,
            serviceFriendlyName: (it.serviceFriendlyName.value &&
              it.serviceFriendlyName.value.length > 0
              ? it.serviceFriendlyName.value
              : it.slotType) ?? "",
            slotTypes,
          });

          return items;
        },
        [] as editService[]
      );

      sendInfoCompanyToUpdate.services = newService; 
      const tempArray = {
        id: idTheme,
        primaryColor: currentForm.themes.primaryColor,
        secondaryColor: currentForm.themes.secondaryColor,
        iconColor: currentForm.themes.iconColor,
        primaryFont: currentForm.themes.primaryFont,
        primaryFontColor: currentForm.themes.primaryFontColor,
        secondaryFontColor: currentForm.themes.secondaryFontColor,
      };

      sendInfoCompanyToUpdate.themes = new Array(tempArray);

      axiosService
        .put(
          `api/widgets/${searchUrl.widgetId as string}/company/${searchUrl.companyId as string
          }`,
          sendInfoCompanyToUpdate
        )
        .then((response) => {
          localStorage.removeItem("service");
        })
        .then(() => {
          let urlImgUpdate = `/api/widgets/${searchUrl.widgetId as string
            }/company/${searchUrl.companyId as string}/logo`;
          let payloadImg = {} as any;
          payloadImg["image"] = imgUploaded;
          axiosService.put(urlImgUpdate, payloadImg).then(() => {
            setImagUpload("");
            history.push("/admin/widget");
          });
        })
        .catch((error) => {
          showNotification(
            "Error from Server",
            "Error message: " + error,
            "warning"
          );
          return console.log(error);
        });
    } else {
      const handleError = { ...errors } as { [key: string]: any };

      if (currentForm.company.successwareCompanyId.length === 0) {
        showNotification(
          "Widget",
          "Error, you have to choose a company",
          "warning"
        );
        handleError["id"] = 1;
        setErrors(handleError);
      } else if (currentForm.company.name.length === 0) {
        showNotification(
          "Widget",
          "Error, company name can't be empty",
          "warning"
        );
        handleError["name"] = 1;
        setErrors(handleError);
      } else if (currentForm.company.streetAddress.length === 0) {
        showNotification(
          "Widget",
          "Error, Street Address can't be empty",
          "warning"
        );
        handleError["streetAddress"] = 1;
        setErrors(handleError);
      } else if (currentForm.company.city.length === 0) {
        showNotification("Widget", "Error, City can't be empty", "warning");
        handleError["city"] = 1;
        setErrors(handleError);
      } else if (currentForm.company.state.length === 0) {
        showNotification("Widget", "Error, State can't be empty", "warning");
        handleError["state"] = 1;
        setErrors(handleError);
      } else if (currentForm.company.zipCode.length === 0) {
        showNotification("Widget", "Error, ZipCode can't be empty", "warning");
        handleError["zipcode"] = 1;
        setErrors(handleError);
      } else if (currentForm.company.img.length === 0 && imgUploaded.length === 0) {
        showNotification("Widget", "Error, Logo can't be empty", "warning");
        handleError["img"] = 1;
        setErrors(handleError);
      } else if (services.length === 0 || openService === 1) {
        if (openService === 0)
          showNotification(
            "Widget",
            "Error, You have to add a service",
            "warning"
          );
        handleError["slotTypes"] = 1;
        setErrors(handleError);
      } else if (currentForm.themes.primaryColor.length === 0) {
        showNotification(
          "Widget",
          "Error, Primary Color can't be empty",
          "warning"
        );
        handleError["primaryColor"] = 1;
        setErrors(handleError);
      } else if (currentForm.themes.secondaryColor.length === 0) {
        showNotification(
          "Widget",
          "Error, Secondary Color can't be empty",
          "warning"
        );
        handleError["secondaryColor"] = 1;
        setErrors(handleError);
      } else if (currentForm.themes.iconColor.length === 0) {
        showNotification(
          "Widget",
          "Error, Icon Color can't be empty",
          "warning"
        );
        handleError["iconColor"] = 1;
        setErrors(handleError);
      } else if (currentForm.themes.primaryFontColor.length === 0) {
        showNotification(
          "Widget",
          "Error, Primary Font Color can't be empty",
          "warning"
        );
        handleError["primaryFontColor"] = 1;
        setErrors(handleError);
      } else if (currentForm.themes.secondaryFontColor.length === 0) {
        showNotification(
          "Widget",
          "Error, Secondary Font Color can't be empty",
          "warning"
        );
        handleError["secondaryFontColor"] = 1;
        setErrors(handleError);
      } else if (currentForm.themes.primaryFont.length === 0) {
        showNotification(
          "Widget",
          "Error, Primary Font can't be empty",
          "warning"
        );
        handleError["primaryFont"] = 1;
        setErrors(handleError);
      }
    }
  };

  /**
   * Entry point of Edit service
   */
  useEffect(() => {
    GoogleAnalyticsConfiguration.sendPageView("Edit Widget");
    const value = queryString.parse(window.location.search);
    reteriveCompayFromServer(value["widgetId"] as string, value["companyId"] as string);
  }, []);


  useEffect(() => { }, [form, editServiceCurrent, imgUploaded, errors]);
  useEffect(() => {}, [serverDataReady]);
  return (
    <>
      <ReactNotification />
      <Header />
      <div className="h-full w-full  bg-customGray flex flex-col">
        <h1 className="text-3xl text-customBlue custom-title-successware mx-auto mt-10 mb-6 ">
          Edit Booking Widget
        </h1>
        <Company
          data={form.company}
          onChange={(prop, value) => handleOnChange("company", prop, value)}
          imgUploaded={imgUploaded}
          errors={errors}
        />
        <hr className="divider w-3/4 mx-auto" />
        <Service
          values={values}
          onChange={setValues}
          editInfoService={editServiceCurrent}
          errors={errors}
          serverDataReady={serverDataReady}
        />
        <hr className="divider w-3/4 mx-auto" />
        <Theme
          data={form.themes}
          onChange={(prop, value) => handleOnChange("themes", prop, value)}
          errors={errors}
        />
        <hr className="divider w-3/4 mx-auto" />
        <div className="m-3 flex flex-col w-1/2 mx-auto my-auto  pb-4 pt-4 md:flex-row md:justify-end md:w-3/4 max-w-6xl">
          <Link to="/admin/widget">
            <button
              onClick={() => clean()}
              className="font-bold text-customBlue custom-btn-preview-widget mb-3 md:mb-0 md:mr-5"
            >
              Cancel
            </button>
          </Link>
          <button
            className="font-bold text-customBlue custom-btn-add-service"
            onClick={updateCompany}
          >
            Update Widget
          </button>
        </div>
      </div>
    </>
  );
};
export default EditWidget;
